const send_command = 'sendCommand';
const start_loading = 'startLoading';
const stop_loading = 'stopLoading';
const height_change = 'heightChange';
const show_modal = 'showModal';
const hide_navbar = 'hideNavbar';
const show_navbar = 'showNavbar';
const get_current_language = 'getCurrentLanguage';
const toast = 'toast';
const get_application = 'getApplication';
const has_permissions = 'hasPermissions';
const get_permissions_object = 'getPermissionsObject';
const get_user_context = 'getUserContext';

export {
    send_command,
    start_loading,
    stop_loading,
    height_change,
    show_modal,
    hide_navbar,
    show_navbar,
    get_current_language,
    toast,
    get_application,
    has_permissions,
    get_permissions_object,
    get_user_context
};
